export default "__VITE_ASSET__DAeLakE5__"